module.exports = __webpack_public_path__ + "img/34-None.e5a2f811.png";